import React, { useState, useEffect, useRef } from 'react';

function EditTimeModal({ termination, onSave, onClose, loading }) {
  const modalRef = useRef(null);
  const inputRef = useRef(null);

  const formatForInput = (isoString) => {
    if (!isoString) return '';
    try {
      const date = new Date(isoString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch {
      return '';
    }
  };

  const [newTime, setNewTime] = useState(formatForInput(termination.processing_time));

  useEffect(() => {
    inputRef.current?.focus();

    const handleKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
        return;
      }
      if (e.key === 'Tab') {
        const focusable = modalRef.current?.querySelectorAll(
          'input, button:not(:disabled), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable?.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newTime) return;
    const isoTime = new Date(newTime).toISOString();
    onSave(termination.ticket_key, isoTime);
  };

  return (
    <div className="modal-overlay" role="presentation" onClick={onClose}>
      <div
        ref={modalRef}
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 id="edit-modal-title">Edit Processing Time</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close dialog"
          >
            &times;
          </button>
        </div>
        <div className="modal-body">
          <p>
            <strong>Ticket:</strong> {termination.ticket_key}
          </p>
          <p>
            <strong>Employee:</strong> {termination.terminated_user}
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="processing-time">New Processing Time:</label>
              <input
                ref={inputRef}
                type="datetime-local"
                id="processing-time"
                value={newTime}
                onChange={(e) => setNewTime(e.target.value)}
                required
              />
            </div>
            <div className="modal-actions">
              <button type="button" onClick={onClose} className="cancel-button">
                Cancel
              </button>
              <button type="submit" className="save-button" disabled={loading || !newTime}>
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditTimeModal;
